import {SidebarTrigger} from "@/components/ui/sidebar";
import {useStoredCompany} from "@/src/modules/company/store";
import {DirectMessagesSidebarLink} from "@/src/modules/direct-messages/components/direct-messages-sidebar-link";
import {NotificationFeedBellButton} from "@/src/modules/notification-feed/components";

import {useIsMobile, useIsPropertyBannerVisible} from "../hooks";
import {useStoredMe} from "../store/me";
import {useStoredUserProperty} from "../store/user-property";
import {APP_BRAND_NAME, LOGO_URL_MOBILE} from "../utils/constants";

import {NavUser} from "./nav-user";
import {ResidentBoardNavTrigger} from "./resident-board-nav-sheet";
import {ResidentBrandHomeLink} from "./resident-brand-home-link";
import {ResidentContextSwitcher} from "./resident-context-switcher";

export default function MobileHeader() {
  const isMobile = useIsMobile();
  const company = useStoredCompany();
  const me = useStoredMe();
  const isResidentShell = Boolean(me?.isResident);
  const property = useStoredUserProperty();
  const isPropertyBannerVisible = useIsPropertyBannerVisible();

  if (!isMobile) {
    return null;
  }

  return (
    <header className="z-20 w-full shrink-0 bg-background shadow-sm">
      <div className="flex min-h-14 items-center justify-between gap-2 px-2 py-2.5">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          {!isResidentShell ? <SidebarTrigger className="size-10 shrink-0" /> : null}
          <ResidentBrandHomeLink
            isResident={isResidentShell}
            className="flex min-w-0 flex-1 items-start gap-2.5 rounded-md px-1 py-0.5 -mx-1"
          >
            <img
              width="35"
              height="35"
              alt="logo"
              src={LOGO_URL_MOBILE}
              className="size-[35px] shrink-0"
            />
            <div className="flex min-w-0 flex-1 flex-col gap-0.5 pt-0.5">
              <h1 className="line-clamp-2 text-[13px] leading-snug font-semibold text-foreground">
                {company?.name ?? APP_BRAND_NAME}
              </h1>
              {company?.name ? (
                <p className="truncate text-[10px] leading-none text-muted-foreground">
                  {APP_BRAND_NAME}
                </p>
              ) : null}
            </div>
          </ResidentBrandHomeLink>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          {isResidentShell ? <NavUser me={me} variant="header" /> : null}
          <ResidentBoardNavTrigger />
          <DirectMessagesSidebarLink />
          <NotificationFeedBellButton badgeVariant="dot" />
        </div>
      </div>
      {isResidentShell ? (
        <div className="border-border border-t px-2 py-2">
          <ResidentContextSwitcher />
        </div>
      ) : isPropertyBannerVisible && property?.name ? (
        <div className="flex h-8 items-center justify-center bg-primary/10 text-sm font-semibold text-primary">
          {property.name}
        </div>
      ) : null}
    </header>
  );
}
